import { NotebookResourceType } from "models/enumerations/notebooks/notebook-resource-type";
import { NotebookShareScope } from "models/enumerations/notebooks/notebook-share-scope";
import { PermissionScope } from "models/enumerations/notebooks/permission-scope";
import { NotebookResourcePermission } from "models/interfaces/notebooks/notebook-resource-permission";
import NotebookPermissionManifestRecord from "models/view-models/notebooks/notebook-permission-manifest-record";
import NotebookResourcePermissionRecord from "models/view-models/notebooks/notebook-resource-permission-record";
import QueryHookFactory from "utilities/hooks/queries/query-hook-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface NotebookPermissionBasePathParams {
    notebookId: number;
}
export interface NotebookPermissionResourcePathParams
    extends NotebookPermissionBasePathParams {
    permissionId: number;
}
export interface NotebookPermissionQueryParams {}
export interface NotebookPermissionPostParams
    extends Omit<NotebookResourcePermission, "recipient"> {
    pageIds: number[];
}
export interface NotebookPermissionPutParams {
    permission: PermissionScope;
    shareScope: NotebookShareScope;
    resourceType: NotebookResourceType;
    pageIds?: number[];
}
export interface NotebookPermissionBulkDeleteQueryParams {
    permissionIds: number[];
}

const baseEndpoint: string = "notebooks/:notebookId/permissions";
const resourceType = NotebookResourcePermissionRecord;
const resourceEndpoint = `${baseEndpoint}/:permissionId`;
const key = "notebook-permissions";

export const NotebookPermissionService = {
    useListQuery: QueryHookFactory.useNestedListQuery<
        NotebookPermissionManifestRecord,
        NotebookPermissionBasePathParams,
        NotebookPermissionQueryParams
    >(key, NotebookPermissionManifestRecord, baseEndpoint),

    useCreate: ServiceHookFactory.useNestedCreateFromPostParams<
        NotebookResourcePermissionRecord,
        NotebookPermissionPostParams,
        NotebookPermissionBasePathParams
    >(resourceType, baseEndpoint),

    useUpdate: ServiceHookFactory.useUpdateFromPutParams<
        NotebookResourcePermissionRecord,
        NotebookPermissionPutParams,
        NotebookPermissionResourcePathParams
    >(resourceType, resourceEndpoint),

    useDelete:
        ServiceHookFactory.useDelete<NotebookPermissionResourcePathParams>(
            resourceEndpoint
        ),

    useBulkDelete: ServiceHookFactory.useBulkDelete<
        NotebookPermissionBasePathParams,
        NotebookPermissionBulkDeleteQueryParams
    >(baseEndpoint),
};
